<template>
  <el-checkbox-group v-model="innerValidList" @change="handleChange">
    <el-checkbox
      v-for="item in options"
      :key="item.value"
      :label="item.value"
    >
      {{ item.label }}
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  name: 'SafeCheckboxGroup',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      innerValidList: []
    }
  },
  computed: {
    validValues() {
      // 提取出合法的value列表
      return this.options.map(item => item.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.updateInnerValidList(val)
      }
    }
  },
  methods: {
    updateInnerValidList(val) {
      this.innerValidList = (val || []).filter(item => this.validValues.includes(item))
    },
    handleChange(validSelected) {
      const invalidList = (this.value || []).filter(item => !this.validValues.includes(item))
      const newValue = [...invalidList, ...validSelected]
      this.$emit('input', newValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/checkboxWrapper.vue